import api from "@helpers/api";

import { URLS } from "@constants/urls";

const { LEAVE, HISTORY_LIST, EMPLOYEES } = URLS;

const apiEndPointBaseURL = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${LEAVE}/${HISTORY_LIST}/${EMPLOYEES}`;

export const getLeaveHistoryList = (() => {
  return async (data: any): Promise<{ data: any }> => {
    const { query, employeeId } = data as any;
    return api
      .get(`${apiEndPointBaseURL}/${employeeId}`, {
        params: query,
      })
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();
